import { Button } from "@/common/components/button";
import { LargeCard } from "../../stats/subs/LargeCard";
import {
  fundAllocationCards,
  fundAllocationTableHeaders,
  fundAllocationTableKeys,
  getFundAllocationTableData,
} from "../data";
import { FundAllocationWrapper } from "../styles";
import { useNavigate } from "react-router-dom";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { useState } from "react";

const FundAllocationHistory = () => {
  const [fundAllocationPerPage, setFundAllocationPerpage] = useState(10);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/dashboard/state-sec/dashboard/drf");
  };

  const {
    data: fundAllocationData,
    meta: fundAllocationMeta,
    loading: fundAllocationLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${fundAllocationPerPage}&page=${fundAllocationPerPage}`
  );

  return (
    <FundAllocationWrapper>
      <div className="button-section">
        <Button onClick={handleClick}>Back</Button>
      </div>
      <div className="card-wrapper">
        {fundAllocationCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={fundAllocationTableHeaders}
          tableKeys={fundAllocationTableKeys}
          tableData={getFundAllocationTableData(fundAllocationData)}
          tableTitle="Fund Allocation History"
          loading={fundAllocationLoading}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={fundAllocationMeta?.total_pages}
          onNextPage={(event: any) => setFundAllocationPerpage(event.selected)}
          onPerPageChange={(event: any) =>
            setFundAllocationPerpage(event?.target?.value)
          }
        />
      </div>
    </FundAllocationWrapper>
  );
};

export default FundAllocationHistory;
